var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bookmark_added_FILL0_wght400_GRAD0_opsz48 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bookmark_added_FILL0_wght400_GRAD0_opsz48-Copy",
    fill: "#505050",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2178218,4.96551724 L8.11881188,2.77241379 L8.95049505,1.88275862 L10.2178218,3.20689655 L13.1485149,0.124137931 L14,1.0137931 L10.2178218,4.96551724 Z M0,15 L0,1.24137931 C0,0.910344828 0.118811881,0.620689655 0.356435644,0.372413793 C0.594059406,0.124137931 0.871287129,0 1.18811881,0 L6.93069307,0 L6.93069307,1.24137931 L1.18811881,1.24137931 L1.18811881,13.1172414 L5.54455446,11.1931034 L9.9009901,13.1172414 L9.9009901,6.20689655 L11.0891089,6.20689655 L11.0891089,15 L5.54455446,12.5172414 L0,15 Z M1.18811881,1.24137931 L6.93069307,1.24137931 L5.54455446,1.24137931 L1.18811881,1.24137931 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProducts);
export default __webpack_public_path__ + "static/media/my_products.4b50aa7abfd900cc9544457eb6cb1fff.svg";
export { ForwardRef as ReactComponent };